import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 5a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z","key":"svg-0"}]]

const IconCropLandscapeFilled = createReactComponent('filled', 'crop-landscape-filled', 'CropLandscapeFilled', __iconNode);

export default IconCropLandscapeFilled;